import {
  ShoppingCart, Users, BarChart3, FileText, Gavel 
} from 'lucide-react';
import { Permission } from '@/types/auth';
import { type NavItem } from './navigation-types';

export const procurementNavItems: NavItem[] = [
  {
    id: 'procurement',
    label: 'Procurement',
    href: '/procurement',
    icon: ShoppingCart,
    permissions: [Permission.VIEW_POS],
    children: [
      {
        id: 'procurement-requests',
        label: 'Purchase Requests',
        href: '/procurement/requests',
        icon: ShoppingCart,
        permissions: [Permission.VIEW_POS] 
      },
      {
        id: 'procurement-sourcing',
        label: 'Sourcing Events',
        href: '/procurement/sourcing',
        icon: ShoppingCart,
        permissions: [Permission.MANAGE_SOURCING] 
      },
      {
        id: 'procurement-bids',
        label: 'Bids',
        href: '/procurement/bids',
        icon: ShoppingCart,
        permissions: [Permission.MANAGE_SOURCING] 
      },
      {
        id: 'procurement-orders',
        label: 'Purchase Orders',
        href: '/procurement/orders',
        icon: FileText,
        permissions: [Permission.VIEW_POS] 
      },
    ],
  },
  {
    id: 'suppliers',
    label: 'Suppliers',
    href: '/suppliers',
    icon: Users,
    permissions: [Permission.VIEW_SUPPLIERS],
    children: [
      {
        id: 'suppliers-directory',
        label: 'Directory',
        href: '/suppliers/directory',
        icon: Users,
        permissions: [Permission.VIEW_SUPPLIERS] 
      },
      {
        id: 'suppliers-performance',
        label: 'Performance',
        href: '/suppliers/performance',
        icon: BarChart3,
        permissions: [Permission.VIEW_SUPPLIERS] 
      },
    ],
  },
  {
    id: 'sourcing',
    label: 'Sourcing',
    href: '/sourcing',
    icon: Gavel,
    permissions: [Permission.MANAGE_SOURCING],
    children: [
      {
        id: 'sourcing-events',
        label: 'All Events',
        href: '/sourcing',
        icon: Gavel,
        permissions: [Permission.MANAGE_SOURCING] 
      },
      {
        id: 'sourcing-auctions',
        label: 'Reverse Auctions',
        href: '/sourcing/auctions',
        icon: Gavel,
        permissions: [Permission.MANAGE_SOURCING] 
      },
      {
        id: 'sourcing-proposals',
        label: 'Sealed Proposals',
        href: '/sourcing/proposals',
        icon: FileText,
        permissions: [Permission.MANAGE_SOURCING] 
      },
      {
        id: 'sourcing-create',
        label: 'Create Event',
        href: '/sourcing/create',
        icon: Gavel,
        permissions: [Permission.MANAGE_SOURCING] 
      },
    ],
  },
];
